import React from 'react'
import GridCard from './GridCard'
import labels from '../../configuration/labels'

import moment from 'moment'
import _ from 'lodash'

import '../../styles/scss/components/grid/grid-cards.scss'

const GridCards = ({ events, isCategoryFilterActive, label }) => {
  let renderEventsCards = []

  if (!_.isEmpty(events)) {
    const sortedEvents = _.sortBy(events, function (o) {
      return new moment(o.activeDates.startDate)
    })

    for (const eventKey in sortedEvents) {
      renderEventsCards.push(
        <GridCard
          key={'grid-card-' + eventKey}
          eventData={sortedEvents[eventKey]}
        />
      )
    }
  }

  return (
    <div className="flow-events__grid-cards">
      <h6>
        Events For <span className="u-font-bold">{label}</span>
      </h6>

      {!_.isEmpty(renderEventsCards) ? (
        renderEventsCards
      ) : isCategoryFilterActive ? (
        <p className="event-unavailable u-remove-margin">
          {labels.filteredEventsUnavailableMessage}
        </p>
      ) : (
        <p className="event-unavailable u-remove-margin">
          {labels.generalEventsUnavailableMessage}
        </p>
      )}
    </div>
  )
}

export default GridCards
